import { Gift } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface AuthPromoBadgeProps {
  message: string
  className?: string
}

export const AuthPromoBadge: React.FC<AuthPromoBadgeProps> = ({
  message,
  className,
}): ReactNode => (
  <div
    className={cn(
      'auth-promo-badge animate-promo-wiggle inline-flex items-center gap-1.5 rounded-full bg-[linear-gradient(135deg,var(--saaga-primary-800),var(--saaga-primary-600),var(--saaga-primary-400))] px-4 py-2 shadow-md',
      className
    )}
  >
    <Gift className="h-4 w-4 mt-[-2px] shrink-0 text-white" />
    <span className="text-sm font-semibold  text-white max-w-[310px]">{message}</span>
  </div>
)
